import eventListStore from '@modules/event/event-list-store';
import eventViewStore from '@modules/event/event-view-store';
import eventImporterStore from '@modules/event/event-importer-store';
import eventFormStore from '@modules/event/event-form-store';
import eventDestroyStore from '@modules/event/event-destroy-store';

export default {
  namespaced: true,

  modules: {
    destroy: eventDestroyStore,
    form: eventFormStore,
    list: eventListStore,
    view: eventViewStore,
    importer: eventImporterStore,
  },
};
